/* eslint-disable no-use-before-define */
import { env } from '@hb/mbridge';
import { CategoryId } from '../common/constants/commonConstants';
import { isAli, isWeixin } from '../common/env/env';
import { appQueryConfig } from '../common/utils/url';

/** 两轮业务线枚举 */
export enum BikeBizId {
  BICYCLE,
  MOPED,
}

/** 两轮业务线渠道code */
export const BikeChannelCode: Record<BikeBizId, number> = {
  [BikeBizId.BICYCLE]: 101000,
  [BikeBizId.MOPED]: 102000,
} as const;

/** 类目ID到两轮业务线的映射 */
export const CategoryBizId = {
  [CategoryId.BIKE]: BikeBizId.BICYCLE,
  [CategoryId.EBIKE]: BikeBizId.MOPED,
};

/** 获取渠道： -1: 全渠道 0:android 10:ios 1:支付宝 2:微信 3:h5 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=198528047 */
export const getPlatform = () => {
  if (env.isHelloFamilyApp) {
    if (env.isAndroid) {
      return 0;
    }

    if (env.isIOS) {
      return 10;
    }
  }

  if (isAli) {
    return 1;
  }

  if (isWeixin) {
    return 2;
  }

  return 3;
};

interface IFilterParams {
  filterCoBranded?: boolean;
  commodityGuid?: string;
}

interface IExtraParams {
  coBrandedPartyCodes?: string[];
}

export interface BikeCommonReqParams {
  _uuid: string | undefined;
  /** 版本号 */
  version: string;
  cityCode: string;
  adCode: string;
  /** 来源 */
  adSource: string;
}

export interface BikeCardReqParams extends BikeCommonReqParams {
  /** 业务线：0：单车1：助力车 */
  businessId: BikeBizId;
  /** -1: 全渠道 0:android 10:ios 1:支付宝 2:微信 3:h5 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=198528047 */
  platform: number;
  /** 渠道列表 */
  channelCodes: number[];
  lat: string;
  lng: string;
  extraParams?: IExtraParams;
  filterParams?: IFilterParams;
  active?: number;
}

export interface BuyBikeCardReqParams extends BikeCommonReqParams {
  /** -1: 全渠道 0:android 10:ios 1:支付宝 2:微信 3:h5 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=198528047 */
  packagePlatform: number;
  bizContent: {
    channelCode: number;
    /** 业务线标示,1=单车；2=助力车 */
    businessType: 1 | 2;
    /** 本次下单的总金额 */
    totalPrice: string;
    packageList: (Pick<Package, 'actualPrice' | 'packageGuid' | 'pendingInfos'> & {
      /** 1-两轮骑行卡 2-权益礼包(暂无) */
      category: 1 | 2;
    })[]
  };
  location: {
    lat: string;
    lng: string;
  };
}

export interface BikeOrderRes {
  orderGoPayList: BikeOrderGoPay[];
  businessType: string;
  businessScene: string;
  totalAmount: number | string;
  wechatSignTempId?: string;
}

export interface BikeOrderGoPay {
  orderNo: string;
  businessType: string;
  /** 支付单号——暂时没用 */
  paymentId?: string;
  /** 支付凭证——前端根据此字段拉收银台 */
  payNo: string;
  payPrice: string;
}

/** 两轮套餐数据 */
export interface PkgData {
  mobilePhone: string;
  twMemberInfo: TwMemberInfo;
  buyLimits: BuyLimit[];
  monthlyInfo: MonthlyInfo[];
  packageGroups: PackageGroup[];
  activityCoupons: ActivityCoupon[];
  algoTraceId: string;
  bizCityCode: string;
  bizCityName: string;
}

interface ActivityCoupon {
  couponGuid?: string;
  couponBatch?: string;
  couponName?: string;
  days?: number;
  desc?: string;
  rideCardType?: string;
  usePortList?: number[];
  discount?: number;
  startTime?: number;
  endTime?: number;
}

export interface BuyLimit {
  buyLimitType: number;
  upLimit: number;
  remain: number;
}

export interface MonthlyInfo {
  openMonthlyStatus: number;
  businessType: number;
}

export interface PackageGroup {
  shelfGuid: string;
  channelCode: number;
  businessType: number;
  licenseRightsType: number;
  canBuy: number;
  maxTyingCount: number;
  packages: Package[];
  buyCardNotice: string;
  exposureNum: number;
}

export interface Package {
  packageGuid: string;
  commodityGuid: string;
  categoryName?: string;
  showName: string;
  originPrice: string;
  purchasePrice: string;
  rideOrderReduceAmount: number;
  paymentLimit: number;
  commodityDesc: string;
  canUseCoupon: boolean;
  cardBatchInfo: CardBatchInfo;
  pendingInfos: PendingInfo[];
  supportPromotion: boolean;
  actualPrice: ActualPrice;
  supportAlgo: boolean;
  cardLogo: string;
  marketingWords?: MarketingWord[];
  wechatSignTempId?: string;
  skuId?: string;
  categoryId?: string;
  marketingTagName?: string;
}

export interface MarketingWord {
  wordsType: number;
  wordsValue: string;
  wordsDesc?: string;
  wordsDescExt?: string;
}

export interface PendingInfo {
  pendingType?: number;
  pendingCode?: string;
  pendingName?: string;
}

export interface ActualPrice {
  finalPrice: string;
  priceSubtitle: string;
  contextKey: string;
  discountAmount: string;
}

export interface CardBatchInfo {
  effectDay: number;
  effectTimes: number;
  limitTimes: boolean;
  usePlatform: number;
  reduceType: number;
  reduceAmountPerTimes: number;
}

export interface TwMemberInfo {
  memberLevel: number;
  levelName: string;
  score: number;
}

/** 获取两轮骑行卡下单 adSource */
export const getBikeAdSource = () => `couponmalltwowheels_${appQueryConfig.adsource}`;
